import React,{useState} from 'react'
import {FaWindows, FaApple, FaLinux, FaAndroid, FaClock} from 'react-icons/fa'
import {formatDate} from './time';

const TopNav = () => {
    let time = new Date().toLocaleTimeString()
    const [ctime, setTime] = useState(time) 

    const updateTime = () => {
        time = new Date().toLocaleTimeString()
        setTime(time)
    }

    setInterval(updateTime,1000)
    return(
         
        <div className="topNav">
            <div className="topNav-title">
                <p>free shopping on </p>
                <div className="topNav-icons">
                    <FaWindows className="topNav-icon" />
                    <FaApple className="topNav-icon" />
                    <FaLinux className="topNav-icon" />
                    <FaAndroid className="topNav-icon" />
                </div>
            </div>
            <div className="clock">
                <FaClock />
                <span className="date">{formatDate}</span>
                <span className="time">{ctime}</span>
            </div>
        </div>
    )
}

export default TopNav
